/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext, useMemo, useState, useCallback } from 'react';
import { useHistory, useParams } from 'react-router';
import { FormattedMessage, useIntl } from 'react-intl';
import { CalloutContext } from '@folio/stripes-core';
import { Layout, Loading } from '@folio/stripes-components';
import { keyBy } from 'lodash';
import { BarcodeLastIndexContext } from '../../../contexts';
import { setDefaultValues } from '../../../utils/utils';
import InstanceWizard from '../InstanceWizard';
import useControlledVocab from '../../../hooks/useDataQueries';
import CreateProgressModal from './CreateProgressModal';

function CreateInstance() {
  const { configId, barcodeLastIndex } = useContext(BarcodeLastIndexContext);
  const history = useHistory();
  const { templateId } = useParams();
  const intl = useIntl();
  const context = useContext(CalloutContext);
  const { data, pending } = useControlledVocab();

  // Modal state management - following EditInstance pattern
  const [formValues, setFormValues] = useState({});
  const [openSubmitProgress, setOpenSubmitProgress] = useState(false);

  const holdingSourceId = useMemo(() => {
    if (!pending) {
      return keyBy(data.holdingsSources, 'name').FOLIO?.id;
    }
    return '';
  }, [pending]);

  const currentTemplate = useMemo(() => {
    if (!pending) {
      return data.templates.find((template) => template.id === templateId);
    }
    return {};
  }, [templateId, pending]);

  const localizedTemplateName = useMemo(() => {
    if (!pending) {
      return currentTemplate?.name?.find(
        (field) => field?.locale === intl.locale,
      )?.value;
    }
    return '';
  }, [pending, templateId]);

  const initialValues = useMemo(() => {
    if (!pending) {
      return {
        instanceData: {
          ...setDefaultValues(currentTemplate?.templateFields?.instance),
          templateTypeId: currentTemplate?.id,
        },
        holdingsData: [],
        itemsData: {},
      };
    }
    return {};
  }, [pending, templateId]);

  const onSubmit = useCallback(
    async (values) => {
      // Following EditInstance pattern - store values and open modal instead of direct API call
      values.holdingSourceId = holdingSourceId;
      values.config = { configId, barcodeLastIndex };

      setFormValues(values);
      setOpenSubmitProgress(true);
    },
    [holdingSourceId, configId, barcodeLastIndex],
  );

  // const id = JSON.parse(JSON.stringify(templateId));

  return (
    <>
      <CreateProgressModal
        open={openSubmitProgress}
        onClose={() => setOpenSubmitProgress(false)}
        formValues={formValues}
        history={history}
        context={context}
      />
      {!pending && (
        <InstanceWizard
          actionType="create"
          appIcon="plus-sign"
          currentTemplate={currentTemplate}
          originTemplateId={JSON.parse(JSON.stringify(templateId))}
          initialValues={initialValues}
          isLoading={pending}
          onSubmit={onSubmit}
          paneTitle={
            <FormattedMessage
              id="ui-plugin-inventory-templates.instanceWizard.create.pane.paneTitle"
              values={{ template: localizedTemplateName }}
              defaultMessage="Create new instance ({template})"
            />
          }
          controlledVocab={data}
        />
      )}
      {pending && (
        <Layout
          className="centered full"
          style={{ maxWidth: '15rem', height: '8rem' }}
        >
          &nbsp;
          <Loading size="xlarge" />
        </Layout>
      )}
    </>
  );
}

CreateInstance.propTypes = {
  // controlledVocab: PropTypes.object,
};

export default CreateInstance;
